import React from 'react';
import { Dimensions, View, StyleSheet } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { Color, CommonStyles, CommonProperties, FontSize } from '../../../styles';
import { scale } from '../../../utils/scale.utils';
import Avatar from '../../Avatar';
import BaseText from '../../BaseText';
import Button from '../../Button';
import RowView from '../../RowView';

const width = Dimensions.get('window').width;
const isSmallScreen = width <= 320;
const userItemSize = isSmallScreen ? scale(120) : scale(140);
const Item = ({ label, qty }) => {
  return (
    <View style={CommonStyles.centerAlignment}>
      <BaseText style={{ color: Color.primary, fontSize: FontSize.h4 }}>{qty}</BaseText>
      <BaseText style={[CommonStyles.body, { color: Color.grayText }]}>{label}</BaseText>
    </View>
  );
};

const getInitialLetters = (name) => {
  const nameList = name.split(' ');
  return nameList
    .splice(0, 2)
    .map((n) => (n[0] ? n[0].toUpperCase() : ''))
    .join('');
};

const UserItem = ({ onPress, type, name, desc, image }) => {
  return (
    <TouchableOpacity onPress={type === 2 ? onPress : () => {}}>
      <View style={styles.container}>
        {image ? (
          <Avatar
            size={userItemSize}
            style={styles.avatar}
            source={{
              uri: `https://randomuser.me/api/portraits/men/${Math.floor(Math.random() * 100)}.jpg`,
            }}
          />
        ) : (
          <View
            style={{
              backgroundColor: Color.gray,
              width: userItemSize + scale(6),
              height: userItemSize + scale(6),
              borderRadius: (userItemSize + scale(6)) / 2,
              ...CommonProperties.centerAlignment,
              borderWidth: scale(3),
              borderColor: 'white',
              overflow: 'hidden',
            }}
          >
            <BaseText style={{ fontSize: 72, color: Color.accent }}>
              {getInitialLetters(name)}
            </BaseText>
          </View>
        )}
        <View style={[CommonStyles.centerItems, CommonStyles.my3]}>
          <BaseText style={styles.name}>{name}</BaseText>
          <BaseText style={styles.connection}>{desc}</BaseText>
        </View>
        {type === 1 ? (
          <Button
            onPress={onPress}
            label="Pending"
            disabled={true}
            style={styles.button}
            labelStyle={CommonStyles.h4}
          />
        ) : null}
        {type === 0 ? (
          <Button
            onPress={onPress}
            label="Connect"
            style={styles.button}
            labelStyle={CommonStyles.h4}
          />
        ) : null}
        {type === 2 ? (
          <RowView style={styles.more}>
            <Item label="Connections" qty="2.1K" />
            <Item label="Groups" qty="12" />
          </RowView>
        ) : null}
        {type === 3 ? (
          <Button
            onPress={onPress}
            label="Accept"
            style={styles.button}
            labelStyle={CommonStyles.h4}
          />
        ) : null}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    ...CommonProperties.shadow,
    ...CommonProperties.mr4,
    ...CommonProperties.mb3,
    ...CommonProperties.borderRadius1,
    ...CommonProperties.p3,
    minWidth: isSmallScreen ? scale(140) : scale(164),
  },
  avatar: {
    alignSelf: 'center',
  },
  button: {
    ...CommonProperties.borderRadius4,
    ...CommonProperties.py3,
  },
  name: {
    ...CommonProperties.h3,
    color: 'black',
  },
  connection: {
    ...CommonProperties.h4,
    color: Color.grayText,
  },
  more: {
    justifyContent: 'space-around',
  },
});

export default UserItem;
